import React from 'react';

const DeleteIcon = ({width="490",height="490", viewBox="0 0 18 18"}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}>
    <path fill="#FFF" d="M11.204.325l.112.006c.554.052 1.005.464 1.114 1.006l.018.127.005.114-.001 1.272 4.728.04-.048 1.653-1.397-.04-1.135 12.45-.016.098c-.068.29-.291.519-.584.597l-.113.021-.094.006H4.17l-.1-.008c-.297-.041-.545-.243-.649-.526l-.031-.11-.014-.093L2.278 4.53.82 4.495l.048-1.646 4.644.038.035-1.32.005-.11c.053-.552.467-1 1.012-1.108L6.69.33l.115-.005h4.398zm2.872 4.173H3.941L4.92 16.03l8.1.033 1.056-11.565zm-3.62 9.841l.34-8.18 1.656.06-.343 8.23-1.653-.11zm-2.304.031l.04-8.226 1.617.048v8.227l-1.657-.049zM5.586 6.174l1.618-.012.303 8.228-1.658.01-.263-8.226zm5.245-4.239H7.197l-.028.916 3.632.035.03-.951z"/>
  </svg>
);

export default DeleteIcon;
